import React from 'react';
import { FadeIn } from './FadeIn';
export function Hero() {
  return <section className="relative min-h-screen bg-navy flex items-center pt-28 md:pt-32 pb-16 overflow-hidden" data-id="element-132">
      {/* Financial markets background image */}
      <div className="absolute inset-0 bg-cover bg-center bg-no-repeat pointer-events-none" style={{
      backgroundImage: "url('https://cdn.magicpatterns.com/uploads/582pFVyJMnVdrvJyhDkyEk/98727416831068450.jpg')"
    }} data-id="element-133"></div>

      {/* Base navy overlay */}
      <div className="absolute inset-0 bg-navy/70 pointer-events-none" data-id="element-134"></div>

      {/* Crazier multi-color animated glows */}
      <div className="absolute top-[-10%] left-[-10%] w-[600px] h-[600px] rounded-full opacity-50 blur-3xl pointer-events-none animate-blob" style={{
      background: 'radial-gradient(circle, rgba(124,58,237,0.7) 0%, rgba(124,58,237,0) 70%)'
    }} data-id="element-135"></div>

      <div className="absolute top-[20%] right-[-10%] w-[700px] h-[700px] rounded-full opacity-45 blur-3xl pointer-events-none animate-blob" style={{
      background: 'radial-gradient(circle, rgba(0,229,255,0.55) 0%, rgba(0,229,255,0) 70%)',
      animationDelay: '4s'
    }} data-id="element-136"></div>

      <div className="absolute bottom-[-15%] left-[20%] w-[700px] h-[700px] rounded-full opacity-40 blur-3xl pointer-events-none animate-blob" style={{
      background: 'radial-gradient(circle, rgba(225,29,116,0.5) 0%, rgba(225,29,116,0) 70%)',
      animationDelay: '8s'
    }} data-id="element-137"></div>

      <div className="absolute top-[40%] left-[10%] w-[500px] h-[500px] rounded-full opacity-35 blur-3xl pointer-events-none animate-blob" style={{
      background: 'radial-gradient(circle, rgba(200,169,106,0.6) 0%, rgba(200,169,106,0) 70%)',
      animationDelay: '2s'
    }} data-id="element-138"></div>

      {/* Subtle gradient overlay for readability on text side */}
      <div className="absolute inset-0 bg-gradient-to-r from-navy/80 via-navy/40 to-transparent pointer-events-none" data-id="element-139"></div>

      {/* Vibrant grid texture overlay */}
      <div className="absolute inset-0 opacity-[0.04] pointer-events-none" style={{
      backgroundImage: 'linear-gradient(#00E5FF 1px, transparent 1px), linear-gradient(90deg, #00E5FF 1px, transparent 1px)',
      backgroundSize: '5rem 5rem'
    }} data-id="element-140"></div>

      {/* Bottom vignette */}
      <div className="absolute bottom-0 left-0 right-0 h-40 bg-gradient-to-t from-navy to-transparent pointer-events-none" data-id="element-141"></div>

      <div className="max-w-7xl mx-auto px-6 md:px-12 relative z-10 w-full" data-id="element-142">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-12 lg:gap-16 items-center" data-id="element-143">
          {/* Left Column - Portrait */}
          <div className="md:col-span-5 flex justify-center md:justify-start" data-id="element-144">
            <FadeIn delay={0.1} direction="right" data-id="element-145">
              <div className="relative w-full max-w-sm md:max-w-md" data-id="element-146">
                {/* Glowing gradient border */}
                <div className="absolute -inset-1 rounded-3xl opacity-75 blur-md" style={{
                background: 'linear-gradient(135deg, #00E5FF, #7C3AED, #E11D74, #C8A96A)'
              }} data-id="element-147"></div>
                <div className="relative p-2 md:p-3 rounded-3xl bg-navy/80 backdrop-blur-sm" data-id="element-148">
                  <div className="overflow-hidden rounded-2xl" data-id="element-149">
                    <img src="https://cdn.magicpatterns.com/uploads/7T7yyY1hatFDBNYMfeCxvE/WhatsApp_Image_2026-05-16_at_01.37.13.jpg" alt="Sandra J. Gabriel" className="w-full h-[380px] md:h-[460px] lg:h-[520px] object-cover" style={{
                    objectPosition: '55% 25%'
                  }} data-id="element-150" />
                  </div>
                </div>
              </div>
            </FadeIn>
          </div>

          {/* Right Column - Content */}
          <div className="md:col-span-7" data-id="element-151">
            <FadeIn delay={0.2} data-id="element-152">
              <div className="inline-flex items-center px-4 py-1.5 rounded-full border border-electric/30 bg-electric/5 backdrop-blur-sm mb-8" data-id="element-153">
                <span className="w-2 h-2 rounded-full bg-electric mr-2 animate-pulse" data-id="element-154"></span>
                <span className="text-xs uppercase tracking-widest font-medium" style={{
                background: 'linear-gradient(90deg, #00E5FF, #C8A96A)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text'
              }} data-id="element-155">
                  Senior Risk &amp; Technology Executive
                </span>
              </div>
            </FadeIn>

            <FadeIn delay={0.35} data-id="element-156">
              <h1 className="text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-serif leading-[1.05] mb-8" data-id="element-157">
                <span className="text-softwhite" data-id="element-158">Driving Enterprise </span>
                <span style={{
                background: 'linear-gradient(135deg, #00E5FF 0%, #7C3AED 50%, #E11D74 100%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text'
              }} data-id="element-159">
                  Risk Transformation
                </span>
                <span className="text-softwhite" data-id="element-160"> at Global Scale</span>
              </h1>
            </FadeIn>

            <FadeIn delay={0.5} data-id="element-161">
              <p className="text-base md:text-lg text-softwhite/75 max-w-2xl font-light leading-relaxed mb-10" data-id="element-162">
                20+ years leading enterprise risk management, regulatory
                governance, and technology transformation across global
                financial institutions — building robust frameworks, leading
                global teams, and driving strategic alignment between risk
                governance and operational performance.
              </p>
            </FadeIn>

            <FadeIn delay={0.65} data-id="element-163">
              <div className="flex flex-wrap gap-4" data-id="element-164">
                <a href="#experience" className="group relative inline-flex justify-center items-center px-7 py-3.5 font-medium text-sm tracking-wide rounded-sm overflow-hidden text-white shadow-[0_0_30px_rgba(0,229,255,0.35)] hover:shadow-[0_0_40px_rgba(225,29,116,0.5)] transition-shadow duration-300" style={{
                background: 'linear-gradient(135deg, #00E5FF 0%, #7C3AED 100%)'
              }} data-id="element-165">
                  <span className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300" style={{
                  background: 'linear-gradient(135deg, #E11D74 0%, #C8A96A 100%)'
                }} data-id="element-166"></span>
                  <span className="relative z-10" data-id="element-167">View Experience</span>
                </a>
                <a href="#contact" className="inline-flex justify-center items-center px-7 py-3.5 border border-gold text-gold font-medium text-sm tracking-wide hover:bg-gold hover:text-navy hover:shadow-[0_0_30px_rgba(200,169,106,0.5)] transition-all duration-300 rounded-sm" data-id="element-168">
                  Contact Me
                </a>
              </div>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}